import { render, staticRenderFns } from "./ChangeImageUser.vue?vue&type=template&id=6b52affe&scoped=true&"
import script from "./ChangeImageUser.vue?vue&type=script&lang=js&"
export * from "./ChangeImageUser.vue?vue&type=script&lang=js&"
import style0 from "./ChangeImageUser.vue?vue&type=style&index=0&id=6b52affe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b52affe",
  null
  
)

export default component.exports